import { render, staticRenderFns } from "./SelectStudentLinkedParent.vue?vue&type=template&id=7238a5c8&scoped=true&"
import script from "./SelectStudentLinkedParent.vue?vue&type=script&lang=js&"
export * from "./SelectStudentLinkedParent.vue?vue&type=script&lang=js&"
import style0 from "./SelectStudentLinkedParent.vue?vue&type=style&index=0&id=7238a5c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7238a5c8",
  null
  
)

export default component.exports